import { RWebShare } from 'react-web-share';
import { useAccount } from '../../../contexts/Account';

export default function NativeShare(props) {
  const { accountDetails } = useAccount();
  const {
    iconStyle = {
      margin: '8px 24px',
      width: '40px',
      height: '40px',
      cursor: 'pointer',
    },
  } = props;

  let shareContent = {};

  if (accountDetails.userSegment === 'managed_advisory_board') {
    shareContent = {
      formTitle:
        "Let your LinkedIn network know you're building an Advisory Board!",
      title: `Join the ${accountDetails.displayName} Advisory Board!`,
      text: `We\'re seeking new advisory board members at ${accountDetails.displayName}. Join today and help us succeed! Open to anyone who supports our mission!\nRequest an invitation here if you're interested in joining! All perspectives are welcome.`,
      linkedInText: `We're using @advisorycloud to build our advisory board and are seeking outside experts to join our sounding board and help us reach our goals.\nRequest an invitation here if you\'re interested in joining! All perspectives are welcome.`,
      link: `https://app.advisorycloud.com/join/advisors/${accountDetails.slug}/${accountDetails.id}`,
    };
  } else {
    shareContent = {
      formTitle:
        'Let your LinkedIn network know you\'re building an AdvisoryCloud!',
      title: `Join our AdvisoryCloud`,
      text: `We\'re seeking outside experts to join our sounding board and help us reach our goals.\nRequest an invitation here if you're interested in joining! All perspectives are welcome`,
      linkedInText: `We're using @advisorycloud to build our Advisory Board and we\'re seeking new advisory board members for ${accountDetails.displayName}. \nJoin today and help us succeed! Open to anyone who supports our mission! Request an invitation here if you\'re interested in joining! All perspectives are welcome.`,
      link: `https://app.advisorycloud.com/join/advisors/${accountDetails.slug}/${accountDetails.id}`,
    };
  }
  return (
    <RWebShare
      data={{
        text: shareContent.text,
        url: shareContent.link,
        title: shareContent.title,
      }}
    >
      <img src="/icons/message_logo.svg" alt="Message Logo" style={iconStyle} />
    </RWebShare>
  );
}
